















































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import S3Handler from '@/mixins/s3'
import { fileSizeFormat } from '@/utils/fileSize'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import AppDialog from '@/components/AppDialog.vue'
import AppTextarea from '@/components/AppTextarea.vue'
import AppRadio from '@/components/AppRadio.vue'
import { uploadFiles } from '@/modules/File/gql/file.gql'
import {
  financialTypeKeys,
  financialTypeValues
} from '@/modules/LifeInsure/helpers/life-insure'

@Component({
  components: {
    AppDialog,
    AppTextarea,
    AppRadio
  }
})
export default class AppFileUploader extends mixins(S3Handler) {
  @Prop(String) readonly historyMasterType!: string
  @Prop(String) readonly documentType!: string
  @Prop({ type: Boolean, default: false }) readonly value!: boolean
  @Prop(Number) readonly masterId!: string
  @Prop(String) readonly title!: string

  fileUploadDialog = false
  acceptFileTypes = `
    .doc, .docx, .xml, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document,
    application/pdf, image/*
  `

  financialIndex = 0
  financialOptions = financialTypeValues
  financialType = financialTypeKeys

  get disableConfirm () {
    return this.filesInfo.length === 0 || this.filesInfo.length !== this.filesToUpload.length
  }

  get dialogHeight () {
    return this.filesToUpload.length * 44 + 180 + 100
  }

  get ifMultiple () {
    return this.fileType !== 'FINANCIAL_PROOF'
  }

  @Emit('success')
  onSuccess () {
    this.clearFile()
  }

  @Emit('cancel')
  onCancel () {
    this.clearFile()
  }

  @Emit('input')
  onInput () {
    return false
  }

  @Watch('documentType')
  valueChanged (val: string) {
    this.fileType = val
  }
  @Watch('value')
  selectFile (val: boolean) {
    if (val) {
      this.selectFileHandler()
    }
  }

  fileInfoSizeDisplay (index: number) {
    if (this.filesToUpload.length === 0) {
      return '0 B'
    }
    const size = this.filesUploadedSize[index] || 0
    const name = this.filesToUpload[index].name
    const extension = this.$R.last(name.split('.'))
    return fileSizeFormat(size) + ' ' + (extension || '').toUpperCase()
  }

  mounted () {
    this.fileType = this.documentType
  }

  selectFileHandler () {
    const elem = this.$refs.fileBrowser as Vue & { click: () => boolean, value: string | null }
    elem.value = null
    elem.click()
    this.onInput()
  }

  async onFileChanged (e: any) {
    let files = e.target.files || e.dataTransfer.files
    this.filesToUpload = files
    this.fileUploadDialog = true
    if (!this.checkCredentialValid()) {
      await this.getSTSCredentials()
    }

    this.filePrefix = this.masterId + ''

    for (let i = 0; i < files.length; i++) {
      await this.uploadFileToS3(i)
    }
  }

  async uploadConfirm () {
    if (this.filesInfo.length === 0) {
      return
    }
    const { filesInfo, masterId, historyMasterType, notes } = this
    const { financialIndex, financialType } = this

    const filesInput = filesInfo.map(fileInfo => {
      const { url, name, size, type } = fileInfo
      return {
        url: url,
        notes,
        name: name,
        size: size.toString(),
        type: type,
        financialType: type === 'FINANCIAL_PROOF' ? financialType[financialIndex] : null
      }
    })
    try {
      const result = await this.$apollo.mutate({
        mutation: uploadFiles,
        variables: {
          masterId: this.masterId,
          masterType: this.historyMasterType,
          filesInput
        }
      })
      this.fileUploadDialog = false
      const res = result.data.uploadFiles
      if (res) {
        showNotification({
          msg: 'Files uploaded success!',
          type: SnackType.Success
        })
        this.onSuccess()
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
